import { gql } from 'apollo-boost'

// Member QUERY
export const GET_MEMBERS = gql`
  query members(
      $page: Int,
      $perPage: Int,
      $sort: String,
      $memberStatus: [Int],
      $email: String,
      $premium: [Int]
    ){
    members(
      page: $page,
      perPage: $perPage,
      sort: $sort,
      memberStatus: $memberStatus,
      email: $email,
      premium: $premium
    ){
      totalCount
      mstMember {
        memberNo
        email
        memberName
        nickname
        memberStatus
        premium
        memberRank
        systemNotice
        weatherNotice
        climbing
        mountId
        payDate
        payPlan
        addDate
        updDate
      }
    }
  }
`
export const GET_MEMBER = gql`
  query getMember($memberNo: String!){
    getMember(memberNo: $memberNo){
      memberNo
      email
      memberName
      nickname
      memberStatus
      premium
      memberRank
      memberBadge
      systemNotice
      weatherNotice
      climbing
      mountId
      payDate
      payPlan
      addDate
      updDate
    }
  }
`
export const INSERT_MEMBER = gql`
  mutation insertMember(
      $email: String!,
      $passwd: String!,
      $memberName: String!,
      $nickname: String!,
      $memberStatus: Int!,
      $premium: Int!,
      $memberRank: Int!,
      $memberBadge: String!,
      $systemNotice: Int!,
      $weatherNotice: Int!,
      $climbing: Int!,
      $mountId: Int!
    ) {
      insertMember(
        email: $email,
        passwd: $passwd,
        memberName: $memberName,
        nickname: $nickname,
        memberStatus: $memberStatus,
        premium: $premium,
        memberRank: $memberRank,
        memberBadge: $memberBadge,
        systemNotice: $systemNotice,
        weatherNotice: $weatherNotice,
        climbing: $climbing,
        mountId: $mountId
      ) {
        status
        message
    }
  }
`

export const UPDATE_MEMBER = gql`
  mutation updateUser(
      $memberNo: String!,
      $email: String!,
      $passwd: String!,
      $memberName: String!,
      $nickname: String!,
      $memberStatus: Int!,
      $premium: Int!,
      $memberRank: Int!,
      $memberBadge: String!,
      $systemNotice: Int!,
      $weatherNotice: Int!,
      $climbing: Int!,
      $mountId: Int!
    ) {
    updateMember(
      memberNo: $memberNo,
      email: $email,
      passwd: $passwd,
      memberName: $memberName,
      nickname: $nickname,
      memberStatus: $memberStatus,
      premium: $premium,
      memberRank: $memberRank,
      memberBadge: $memberBadge,
      systemNotice: $systemNotice,
      weatherNotice: $weatherNotice,
      climbing: $climbing,
      mountId: $mountId
      ) {
        status
        message
    }
  }
`
export const DELETE_MEMBER = gql`
  mutation deleteMember(
        $memberNo: String!,
    ) {
      deleteMember(
        memberNo: $memberNo,
      ) {
        status
        message
    }
  }
`

// User QUERY
export const GET_USERS = gql`
  query users($page: Int, $perPage: Int, $sort: String){
    users(page: $page, perPage: $perPage, sort: $sort){
      totalCount
      users {
        userId
        loginId
        userName
        roles
      }
    }
  }
`
export const GET_USER = gql`
  query getUser($userId: String!){
    getUser(userId: $userId){
      userId
      state
      loginId
      userName
      roles
      loginDate
      loginIpaddress
      loginAgent
    }
  }
`
export const INSERT_USER = gql`
  mutation insertUser(
        $loginId: String!,
        $passwd: String!,
        $userName: String!,
        $state: String!,
        $roles: String!
    ) {
      insertUser(
        loginId: $loginId,
        passwd: $passwd,
        userName: $userName,
        state: $state,
        roles: $roles
      ) {
        status
        message
    }
  }
`
export const UPDATE_USER = gql`
  mutation updateUser(
        $userId: String!,
        $passwd: String,
        $userName: String!,
        $state: String!,
        $roles: String!
    ) {
    updateUser(
        userId: $userId,
        passwd: $passwd,
        userName: $userName,
        state: $state,
        roles: $roles
      ) {
        status
        message
    }
  }
`
export const DELETE_USER = gql`
  mutation deleteUser(
        $userId: String!,
    ) {
      deleteUser(
        userId: $userId,
      ) {
        status
        message
    }
  }
`
export const LOGIN_USER = gql`
  mutation loginUser($loginId: String!,$passwd: String!) {
    loginUser(loginId: $loginId,passwd: $passwd) {
        userId
        userName
        status
        roles
        accessToken
        refreshToken
        sessionToken
    }
  }
`

export const REFRESH_TOKEN = gql`
  mutation refresh($refreshToken: String!) {
    refresh(refreshToken: $refreshToken){
      newToken
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql.js